export const CATEGORIES_LOADED = 'CATEGORIES_LOADED';
export const ERROR_DATA_CATEGORIES = 'ERROR_DATA_CATEGORIES';
export const LOAD_CATEGORIES = 'LOAD_CATEGORIES';
export const SET_CURRENT_AGENCY = 'SET_CURRENT_AGENCY';
export const LOAD_EXCLUSIONS = 'LOAD_EXCLUSIONS';
export const ERROR_DATA_EXCLUSIONS = 'ERROR_DATA_EXCLUSIONS';
export const EXCLUSIONS_LOADED = 'EXCLUSIONS_LOADED';
export const RESET_EXCLUSIONS = 'RESET_EXCLUSIONS';
export const RESET = 'RESET';
export const ADDED_EXCLUSION = 'ADDED_EXCLUSION';
export const EXCLUSIONS_ACTION_ERROR = 'EXCLUSIONS_ACTION_ERROR';
export const MULTIPLE_EXCLUSIONS_ADDED = 'MULTIPLE_EXCLUSIONS_ADDED';
export const EXCLUSION_EDITED = 'EXCLUSION_EDITED';
